import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

import wordpressLogo from '@/assets/homepage/platforms/wordpress.png';
import webflowLogo from '@/assets/homepage/platforms/webflow.png';
import cloudflareLogo from '@/assets/homepage/platforms/cloudflare.png';
import framerLogo from '@/assets/homepage/platforms/framer.png';
import squarespaceLogo from '@/assets/homepage/platforms/squarespace.png';

interface Platform {
  name: string;
  logo?: string;
}

const platforms: Platform[] = [
  { name: 'WordPress', logo: wordpressLogo },
  { name: 'Webflow', logo: webflowLogo },
  { name: 'Cloudflare', logo: cloudflareLogo },
  { name: 'Framer', logo: framerLogo },
  { name: 'Squarespace', logo: squarespaceLogo },
  { name: 'Custom Sites' },
];

export default function WorksEverywhere() {
  return (
    <section className="flex flex-col items-center px-4 md:px-0">
      <span className="font-body font-semibold text-[12px] tracking-[0.6px] uppercase text-[#1e1c1c] opacity-70 text-center">
        Works Everywhere
      </span>

      <div className="mt-4 w-full">
        <div className="flex items-center justify-center gap-x-6 gap-y-4 flex-wrap">
          {platforms.map((platform) => (
            <div key={platform.name} className="flex items-center gap-3">
              {platform.logo ? (
                <img
                  src={platform.logo}
                  alt={platform.name}
                  className="w-5 h-5 rounded object-cover"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faGlobe}
                  className="text-[#1e1c1c] text-[16px]"
                />
              )}
              <span className="font-body font-medium text-base text-[#1e1c1c]">
                {platform.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
